export default __webpack_public_path__ + "static/media/VFC_Jahresbericht_2020.65614a03.pdf";